import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import { Form, Formik } from 'formik'
import { InputSelectOptions, InputField } from 'components'
import { SELLER_TYPE, GENDER , REFERRER } from 'domains/exclusive-seller/constants'
import exclusiveSellerSchema from './exclusive-seller-schema'
import TimeUtil from 'utils/time-util'
import { ExclusiveSellerContractField } from 'domains/exclusive-seller/molecules/contract-field'
import { LoaderButton } from 'components/molecules'

const propTypes = {
  seller: PropTypes.shape({
    id             : PropTypes.number,
    name           : PropTypes.string,
    username       : PropTypes.string,
    email          : PropTypes.string,
    mobile         : PropTypes.string,
    seller_type    : PropTypes.string,
    contract_id    : PropTypes.number,
    street_address : PropTypes.string,
    birthday       : PropTypes.string,
    kelurahan      : PropTypes.string,
    kecamatan      : PropTypes.string,
    kota           : PropTypes.string,
    provinsi       : PropTypes.string,
    kode_pos       : PropTypes.string,
    bank           : PropTypes.string,
    bank_branch    : PropTypes.string,
    account_number : PropTypes.string,
    account_name   : PropTypes.string,
    referrer       : PropTypes.string,
    gender         : PropTypes.string,
    contract       : PropTypes.shape({
      id      : PropTypes.string,
      type_of : PropTypes.string
    })
  }),
  handleSubmitForm: PropTypes.func
}

const defaultValues = {
  seller           : {},
  handleSubmitForm : () => { }
}

const ExclusiveSellerForm = ({
  seller,
  handleSubmitForm
}) => {
  const mapInitialValue = (seller) => {
    let initialValues = {
      name           : seller?.name || '',
      username       : seller?.username || '',
      email          : seller?.email || '',
      mobile         : seller?.mobile || '',
      seller_type    : seller?.seller_type || '',
      birthday       : seller?.birthday ? TimeUtil.format(seller.birthday, 'YYYY-MM-DD') : '',
      contract_id    : seller?.contract?.id || '',
      street_address : seller?.street_address || '',
      kelurahan      : seller?.kelurahan || '',
      kecamatan      : seller?.kecamatan || '',
      kota           : seller?.kota || '',
      provinsi       : seller?.provinsi || '',
      kode_pos       : seller?.kode_pos || '',
      bank           : seller?.bank || '',
      bank_branch    : seller?.bank_branch || '',
      account_number : seller?.account_number || '',
      account_name   : seller?.account_name || '',
      referrer       : seller?.referrer || '',
      gender         : seller?.gender || ''
    }

    return initialValues
  }

  return (
    <Formik
      enableReinitialize= { true }
      initialValues={ mapInitialValue(seller) }
      validationSchema={ exclusiveSellerSchema }
      onSubmit={ (values, formikBag) => handleSubmitForm(values, formikBag) }
    >
      {
        (formikBag) => (
          <Form>
            <Row>
              <Col>
                <InputField
                  type='text'
                  name='name'
                  label='Name'
                  placeholder='Tinkerlust'
                  required={ true }
                />
                <InputField
                  type='select'
                  name='gender'
                  label='Gender'
                  required={ true }
                >
                  <InputSelectOptions options={ GENDER } keyPrefix={ 'gender' } />
                </InputField>
                <InputField
                  type='select'
                  name='referrer'
                  label='Referrer'
                  required={ true }
                >
                  <InputSelectOptions options={ REFERRER } keyPrefix={ 'referrer' } />
                </InputField>
                <InputField
                  type='text'
                  name='username'
                  label='Username'
                  placeholder='username123'
                  required={ true }
                  disabled={ seller ? true : false }
                />
                <InputField
                  type='date'
                  name='birthday'
                  label='Birthday'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='email'
                  label='Email'
                  placeholder='tinkerlust@gmail.com'
                  disabled={ seller ? true : false }
                  required={ true }
                />
                <InputField
                  type='tel'
                  name='mobile'
                  label='Phone Number'
                  placeholder='62821xxxxxx'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='street_address'
                  label='Street Address'
                  placeholder='Jalan Sisingamangaraja No. 11 A'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='kecamatan'
                  label='Kecamatan'
                  placeholder='Kebayoran Baru'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='kelurahan'
                  label='Kelurahan'
                  placeholder='Gunung'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='kota'
                  label='Kota'
                  placeholder='Jakarta Selatan'
                  required={ true }
                />
              </Col>

              <Col>
                <InputField
                  type='text'
                  name='provinsi'
                  label='Provinsi'
                  placeholder='DKI Jakarta'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='kode_pos'
                  label='Kode Pos'
                  placeholder='12XXX'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='bank'
                  label='Bank Name'
                  placeholder='BCA'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='bank_branch'
                  label='Bank Branch'
                  placeholder='Blok M'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='account_number'
                  label='Bank Account No.'
                  placeholder='450XXXXXXX'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='account_name'
                  label='Bank Account Name'
                  placeholder='Cindy Gulla'
                  required={ true }
                />
                <InputField
                  type='select'
                  name='seller_type'
                  label='Seller Type'
                  disabled={ seller ? true : false }
                  required={ true }
                >
                  <InputSelectOptions options={ SELLER_TYPE } keyPrefix={ 'seller-type' } />
                </InputField>
                <ExclusiveSellerContractField
                  formikBag={ formikBag }
                  fieldName={ 'contract_id' }
                  sellerType={ formikBag.values.seller_type }
                />
                <LoaderButton
                  color='primary'
                  disabled={ formikBag.isSubmitting }
                  isLoading={ formikBag.isSubmitting }
                  onClick={ () => formikBag.submitForm() }
                />
              </Col>
            </Row>
          </Form>
        )
      }
    </Formik>
  )
}

ExclusiveSellerForm.propTypes     = propTypes
ExclusiveSellerForm.defaultValues = defaultValues

export default ExclusiveSellerForm
